import React, { useState, useEffect, useRef } from 'react';
import config from '../../config/config';
import MeetingEndedComponent from './VideoCallPage';

const JitsiMeeting = ({
  roomName,
  displayName,
  userId,
  userName,
  userRole,
  sessionName,
  threadId,
  preferredMethod
}) => {
  const [ended, setEnded] = useState(false);
  const containerRef = useRef(null);
  const apiRef = useRef(null);

  const domain = new URL(config.JITSI_BASE_URL).host;

  useEffect(() => {
    if (!window.JitsiMeetExternalAPI || !containerRef.current) {
      console.error('JitsiMeetExternalAPI not found or container missing');
      return;
    }

    const options = {
      roomName,
      parentNode: containerRef.current,
      userInfo: { displayName },
      configOverwrite: {
        startWithAudioMuted: true,
        disableModeratorIndicator: true,
        prejoinPageEnabled: false,
        disableDeepLinking: true,
        enableClosePage:      false,
      },
      interfaceConfigOverwrite: {
        DISABLE_JOIN_LEAVE_NOTIFICATIONS: true
      },
    };

    apiRef.current = new window.JitsiMeetExternalAPI(domain, options);

    apiRef.current.addEventListener('readyToClose', () => {
      setEnded(true);
    });

    return () => {
      apiRef.current?.dispose();
      apiRef.current = null;
    };
  }, [domain, roomName, displayName]);

  if (ended) {
    return (
      <MeetingEndedComponent
        userId={userId}
        userName={userName}
        userRole={userRole}
        sessionName={sessionName}
        threadId={threadId}
        preferredMethod={preferredMethod}
      />
    );
  }

  return (
    <div
      ref={containerRef}
      className="meeting-main-container"
    />
  );
};

export default JitsiMeeting;
